import React from 'react';
import AdobePluginInstallInstructions from './adobe-plugin';
import type { IntegrationInstallInstructionsProps } from '@pages/AdminSettings/components/IntegrationTab/constants';

export default function InDesignInstallInstructions({
  organizationId,
  installed,
  onClose
}: IntegrationInstallInstructionsProps) {
  return (
    <AdobePluginInstallInstructions
      pluginType="indesign"
      organizationId={organizationId}
      installed={installed}
      onClose={onClose}
    />
  );
}
